// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__TRwt9","tyre":"style_tyre__2A-c6"};